<div class="flat-gauge-chart">
  <div
    class="flat-gauge-chart__needle"
    [style.left.%]="needlePosition"
    [attr.data-value]="needlePosition"
  ></div>
  @if (delimiters.length && colors.length) {
    <div class="flat-gauge-chart__segments">
      <div
        class="flat-gauge-chart__segment"
        [style.left]="0"
        [style.width.%]="delimiters[0]"
        [style.background-color]="colors[0]"
      ></div>
      @for (delimiter of delimiters; track delimiter; let first = $first; let index = $index) {
        @if (!first) {
          <div
            class="flat-gauge-chart__segment"
            [style.left.%]="delimiters[index - 1]"
            [style.width.%]="delimiter - delimiters[index - 1]"
            [style.background-color]="colors[index]"
          ></div>
        }
      }
      <div
        class="flat-gauge-chart__segment"
        [style.left.%]="delimiters[delimiters.length - 1]"
        [style.width.%]="100 - delimiters[delimiters.length - 1]"
        [style.background-color]="colors[colors.length - 1]"
      ></div>
    </div>
  }
</div>
